import React, { useState } from "react";
import { ShieldAlert, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const LIABILITY_VERSION = "2026-11-03";

const POLICY_LINKS = [
  ["/liability", "إقرار حدود المسؤولية"],
  ["/terms", "الشروط والأحكام"],
  ["/refund", "سياسة الاسترجاع"],
  ["/privacy", "سياسة الخصوصية"],
  ["/guide", "نموذج عمل المنصة"],
];

// مربّع الإقرار الإلزامي قبل أي دفع أو تفعيل خدمة — السياسات تُفتح داخل نافذة فوقية حتى لا يفقد العميل خطوة الدفع
export const LiabilityCheckbox = ({ checked, onChange }) => {
  const [doc, setDoc] = useState(null);
  return (
    <>
      <label className="flex items-start gap-3 rounded-xl border border-border bg-secondary/50 p-3 text-xs leading-relaxed cursor-pointer" data-testid="liability-consent">
        <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} className="mt-0.5 w-4 h-4 accent-primary shrink-0" data-testid="liability-consent-checkbox" />
        <span>
          <span className="font-bold text-foreground">أقرّ بأنني اطّلعت على</span>{" "}
          {POLICY_LINKS.map(([to, label], i) => (
            <React.Fragment key={to}>
              <button type="button" onClick={(e) => { e.preventDefault(); e.stopPropagation(); setDoc([to, label]); }}
                className="text-primary underline underline-offset-2" data-testid={`policy-link-${to.slice(1)}`}>{label}</button>
              {i < POLICY_LINKS.length - 1 ? "، " : ""}
            </React.Fragment>
          ))}
          {" "}وفهمتها، وأوافق على تقديم الخدمة بصورة آلية ضمن إمكاناتها المعلنة، وأتفهم أن منصة رواج الذكية لا تضمن نتائج تسويقية أو تجارية محددة،
          وأن مسؤولية مراجعة المخرجات قبل استخدامها تقع عليّ، دون المساس بحقوقي المقررة نظامًا.
          <span className="block mt-1 text-foreground font-bold" data-testid="liability-content-rule">وأتعهد بعدم توليد أي صور أو فيديوهات مخلّة أو تهدف إلى تشويه صورة أشخاص أو التشهير بهم، وأقرّ بأنني أبلغ 18 عامًا فأكثر.</span>
        </span>
      </label>
      {doc && (
        <Dialog open onOpenChange={(o) => !o && setDoc(null)}>
          <DialogContent className="bg-popover border-border max-w-3xl w-[96vw] p-0 overflow-hidden" dir="rtl" data-testid="policy-viewer">
            <DialogHeader className="px-4 pt-4 pb-2">
              <DialogTitle className="flex items-center gap-2 text-base"><ShieldAlert className="w-4 h-4 text-primary" /> {doc[1]}</DialogTitle>
              <DialogDescription className="text-xs">اقرأ ثم اضغط «رجوع» لإكمال الإقرار والدفع — لن تفقد ما بدأته.</DialogDescription>
            </DialogHeader>
            <iframe title={doc[1]} src={`${doc[0]}?embed=1`} className="w-full h-[65vh] bg-background border-t border-border" data-testid="policy-iframe" />
            <div className="p-3 border-t border-border">
              <Button onClick={() => setDoc(null)} className="w-full font-bold gap-2" data-testid="policy-viewer-back"><ArrowRight className="w-4 h-4" /> رجوع لإكمال الإقرار</Button>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

// نافذة موافقة مستقلة للمسارات التي تُفعِّل الخدمة بلا نافذة دفع (كوبون/تجربة/باقة مجانية مخصومة)
export const LiabilityConsentDialog = ({ open, onClose, onAccept, title = "إقرار قبل بدء الخدمة" }) => {
  const [ok, setOk] = useState(false);
  if (!open) return null;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-popover border-border max-w-md" dir="rtl" data-testid="liability-consent-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><ShieldAlert className="w-5 h-5 text-primary" /> {title}</DialogTitle>
          <DialogDescription>اطّلع على السياسات ووافق على الإقرار ليبدأ تقديم الخدمة.</DialogDescription>
        </DialogHeader>
        <LiabilityCheckbox checked={ok} onChange={setOk} />
        <Button onClick={() => onAccept()} disabled={!ok} className="w-full font-bold" data-testid="liability-consent-continue">أوافق وأتابع</Button>
      </DialogContent>
    </Dialog>
  );
};
